/* istanbul ignore file */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { INoticeBanner } from 'src/app/model/notice-banner/notice-banner';

@Component({
  selector: 'app-notice-banner',
  templateUrl: './notice-banner.component.html',
  styleUrls: ['./notice-banner.component.scss']
})
export class NoticeBannerComponent {

  @Input() noticeBanner: INoticeBanner = null;
  //@Input() title: string = 'Account access limited';
  @Input() isVisible: boolean = false;
  @Input() isExternalUrl: boolean = false;
  @Input() isPrimary: boolean = false;
  @Output() closeBanner = new EventEmitter<boolean>();

  close() {
    this.isVisible = false;
    this.closeBanner.emit(this.isVisible);
  }

}
